import type { MetadataFieldDescriptor, MetadataFields } from '../../../View/Component/SampleGrouping/MetadataFields.js'
import { STATIC_METADATA_FIELDS } from '../../../View/Component/SampleGrouping/MetadataFields.js'
import type { VisualizationSampleContainer } from '../../../View/Component/SampleGrouping/VisualizationSampleContainer.js'
import type { SerializableFieldsIndex } from './VisualizationSerializableFields.js'

export function buildCustomDescriptors(customKeys: string[]): Record<string, MetadataFieldDescriptor> {
  const result: Record<string, MetadataFieldDescriptor> = {}
  for (const key of customKeys) {
    const fullKey = `sampleMetadata.customAttributes.${key}`
    result[fullKey] = {
      key: fullKey,
      type: 'string',
      label: `Custom: ${key}`,
      getter: (s: VisualizationSampleContainer) => s.sampleMetadata?.customAttributes?.[key]
    }
  }
  return result
}

/**
 * Turn a serializable index into "live" MetadataFields (with functions).
 * You can pass `customKeysHint` to show the fields even if samples don’t contain them yet (e.g., templates).
 */
export function resolveMetadataFields(index: SerializableFieldsIndex, opts?: { customKeysHint?: string[] }): MetadataFields {
  // grab static descriptors by key from your registry (they already include getter/uiLabel/compKey)
  const staticPart: Record<string, MetadataFieldDescriptor> = {}
  for (const k of index.staticKeys) {
    const desc = STATIC_METADATA_FIELDS[k]
    if (desc) staticPart[k] = desc
  }

  // custom part (runtime getters re-materialized)
  const customKeys = index.customKeys.length ? index.customKeys : (opts?.customKeysHint ?? [])
  const customPart = buildCustomDescriptors(customKeys)

  return { ...staticPart, ...customPart }
}
